import {Search} from 'lucide-react';

import {cn} from '../../lib/utils';
import {Input} from '../shadcn/input';

import type {InputHTMLAttributes, ReactNode} from 'react';

export interface SearchInputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'value' | 'onChange' | 'className'
> {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  endAdornment?: ReactNode;
}

export function SearchInput({
  value,
  onChange,
  placeholder,
  className,
  disabled,
  endAdornment,
  ...inputProps
}: SearchInputProps) {
  return (
    <div data-slot="search-input" className={cn('relative w-64', className)}>
      <Search className="text-fg-tertiary pointer-events-none absolute start-2.5 top-1/2 size-4 -translate-y-1/2" />
      <Input
        {...inputProps}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className={cn('ps-8', endAdornment && 'pe-9')}
      />
      {endAdornment && (
        <div data-slot="end-adornment" className="absolute end-1.5 top-1/2 -translate-y-1/2">
          {endAdornment}
        </div>
      )}
    </div>
  );
}
